import React from 'react';
import {
  Accordion,
  Box,
  Divider,
  Placeholder,
  Stack,
  Text,
  useScreenSize,
} from '@stitch-fix/mode-react';
import DetailsList from '../DetailsList';
import ProductDescription from '../ProductDescription';
import { useProductDetailsPageContext } from '../ProductDetailsPage/ProductDetailsPageContext/ProductDetailsPageContext';

const Header = () => (
  <Placeholder display="block" variant="rect" width={15} height={2} />
);

const Attribute = () => (
  <Placeholder display="block" variant="rect" width={12} height={1} />
);

/**
 * Placeholder for the ProductAttributes component.
 * It's intended that this can be swapped out for the ProductAttributes component when in a loading state.
 */
const ProductAttributesPlaceholder = () => {
  return (
    <>
      <Stack spacing={1} mt={2} mb={2}>
        <Header />
        <Attribute />
        <Attribute />
      </Stack>
      <Stack spacing={1} mt={2} mb={2}>
        <Header />
        <Attribute />
        <Attribute />
      </Stack>
    </>
  );
};

/**
 * Actual content for ProductAttributes component.
 */
const ProductAttributesContent = () => {
  const [state] = useProductDetailsPageContext();
  const attributeCategories =
    state.selectedVariant?.detailGroups ||
    state.fallbackVariant?.detailGroups ||
    [];

  const isMobileScreenSize = useScreenSize() === 'sm';

  return (
    <>
      {attributeCategories
        .filter(category => {
          return category.details?.length;
        })
        .map(category => {
          const heading = <Text setting="title-small">{category.label}</Text>;

          return (
            <React.Fragment key={category.label}>
              {isMobileScreenSize && (
                <Divider variant="section" color="light-gray" />
              )}
              <Accordion
                key={category.key}
                heading={heading}
                headingLevel="h2"
                expandIconAlignment="fixed-end"
                my={{ sm: 1.5, md: 2 }}
                defaultIsExpanded={state.isStaticView}
              >
                {!!state.productDescription &&
                  category.label === 'Product details' && (
                    <ProductDescription text={state.productDescription} />
                  )}
                <DetailsList list={category.details} />
              </Accordion>
              {!isMobileScreenSize && (
                <Divider variant="section" color="light-gray" />
              )}
            </React.Fragment>
          );
        })}
    </>
  );
};

/**
 * This component displays product attributes as a group of `DetailsList`
 * components
 */
const ProductAttributes = () => {
  const [state] = useProductDetailsPageContext();
  const showPlaceholders = state.loading || !state.shopProduct;

  return (
    <Box>
      {showPlaceholders ? (
        <ProductAttributesPlaceholder />
      ) : (
        <ProductAttributesContent />
      )}
    </Box>
  );
};

export default ProductAttributes;
